/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * a unit of time
 * @export
 */
export const TimeUnit = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR',
    Hour: 'HOUR'
} as const;
export type TimeUnit = typeof TimeUnit[keyof typeof TimeUnit];


export function TimeUnitFromJSON(json: any): TimeUnit {
    return TimeUnitFromJSONTyped(json, false);
}

export function TimeUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeUnit {
    return json as TimeUnit;
}

export function TimeUnitToJSON(value?: TimeUnit | null): any {
    return value as any;
}

